// Helpers for sequencing letters across the 5 words.
import { isMusicalLetter, letterToNote } from "@/lib/cryptogram";

// Returns a flat ordered list of droppable letter entries.
// Each entry: { wordIdx, charIdx, letter, note, octave, pitch }
export function buildLetterSequence(words) {
  const out = [];
  words.forEach((word, wordIdx) => {
    if (!word) return;
    for (let i = 0; i < word.length; i += 1) {
      const ch = word[i];
      if (!isMusicalLetter(ch)) continue;
      const n = letterToNote(ch);
      if (!n) continue;
      out.push({
        wordIdx,
        charIdx: i,
        letter: ch.toUpperCase(),
        ...n,
      });
    }
  });
  return out;
}
